module.exports = __webpack_public_path__ + "img/图3  人面鱼纹彩陶盆.678d7739.jpeg";